import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-420">
      <div className="max-w-5xl mx-auto" data-id="element-421">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-422">
          Lo que <span className="text-[#39FF14]" data-id="element-423">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-424">
          <div className="bg-black border border-[#39FF14]/30 rounded-2xl p-6" data-id="element-425">
            <h3 className="text-[#39FF14] text-xl font-black mb-2" data-id="element-426">
              🇧🇷 PRIMARIA + SECUNDARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-427">
              Para docentes de Portugués de primaria y secundaria
            </p>
            <div className="space-y-4" data-id="element-428">
              <div className="flex items-center gap-3 text-white" data-id="element-429">
                <span className="text-xl" data-id="element-430">📘</span>
                <div className="flex-1" data-id="element-431">
                  <span className="font-bold" data-id="element-432">Tomo 1 — Primaria 1°-3°:</span>
                  <span className="text-gray-300" data-id="element-433">
                    {' '}
                    Primeiros Passos (Alfabeto, colores, números, animales,
                    familia y saludos.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-434">
                <span className="text-xl" data-id="element-435">📗</span>
                <div className="flex-1" data-id="element-436">
                  <span className="font-bold" data-id="element-437">Tomo 2 — Primaria 4°-7°:</span>
                  <span className="text-gray-300" data-id="element-438">
                    {' '}
                    Explorando o Português (Rutina, alimentación, vestuario,
                    verbos en presente y los lugares de la ciudad.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-439">
                <span className="text-xl" data-id="element-440">📙</span>
                <div className="flex-1" data-id="element-441">
                  <span className="font-bold" data-id="element-442">Tomo 3 — Secundaria 1°-2°:</span>
                  <span className="text-gray-300" data-id="element-443">
                    {' '}
                    Conexão Brasil Nível 1 (Identidad, Falsos Amigos (Top 25),
                    verbos irregulares, mundo digital y Pretérito Perfeito.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-444">
                <span className="text-xl" data-id="element-445">📕</span>
                <div className="flex-1" data-id="element-446">
                  <span className="font-bold" data-id="element-447">Tomo 4 — Secundaria 3°-4°:</span>
                  <span className="text-gray-300" data-id="element-448">
                    {' '}
                    Conexão Brasil Nível 2 (Pretérito Imperfeito, Futuro,
                    viajes, debate y textos auténticos de actualidad.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-449">
                <span className="text-xl" data-id="element-450">📓</span>
                <div className="flex-1" data-id="element-451">
                  <span className="font-bold" data-id="element-452">Tomo 5 — Secundaria 5°-6°:</span>
                  <span className="text-gray-300" data-id="element-453">
                    {' '}
                    Fluência e Cultura (Subjuntivo, Imperativo, literatura
                    brasileña, cine, música y Português profesional.)
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-454">
                <span className="text-xl" data-id="element-455">📔</span>
                <div className="flex-1" data-id="element-456">
                  <span className="font-bold" data-id="element-457">Tomo 6 — Cierre de Ciclo:</span>
                  <span className="text-gray-300" data-id="element-458">
                    {' '}
                    Português Avançado (Fonética avanzada, ensayos académicos,
                    simulacros CELPE-Bras y Portfolio de cierre.)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#39FF14]/5 border border-[#39FF14]/30 rounded-2xl p-8 text-center" data-id="element-459">
          <h3 className="text-[#39FF14] text-xl font-black mb-6" data-id="element-460">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-461">
            <div className="flex items-start gap-2 text-left" data-id="element-462">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-463">✅</span>
              <span className="text-white text-sm" data-id="element-464">
                Planificación anual completa lista para entregar a jefatura o
                inspección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-465">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-466">✅</span>
              <span className="text-white text-sm" data-id="element-467">
                6 Unidades Didácticas con desarrollo teórico completo y ejemplos
                argentinos y brasileños
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-468">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-469">✅</span>
              <span className="text-white text-sm" data-id="element-470">
                Secuencias didácticas con estructura inicio–desarrollo–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-471">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-472">✅</span>
              <span className="text-white text-sm" data-id="element-473">
                Actividades fotocopiables (3 niveles A/B/C) listas para imprimir
                o compartir por WhatsApp
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-474">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-475">✅</span>
              <span className="text-white text-sm" data-id="element-476">
                Mini evaluaciones + 1 evaluación integradora por tomo con
                criterios de corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-477">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-478">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-479">
                SOLUCIONARIO COMPLETO con todas las respuestas y justificaciones
                pedagógicas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-480">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-481">✅</span>
              <span className="text-white text-sm" data-id="element-482">
                Diploma de conclusión imprimible para cada alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-483">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-484">✅</span>
              <span className="text-white text-sm" data-id="element-485">
                Sección "Falsos Amigos" en todos los niveles (el error más
                costoso del alumno argentino)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-486">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-487">✅</span>
              <span className="text-white text-sm" data-id="element-488">
                Conexión cultural Brasil-Argentina en cada unidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-489">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-490">✅</span>
              <span className="text-white text-sm" data-id="element-491">
                100% alineado al currículo escolar argentino vigente
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-492">
              <span className="text-[#39FF14] font-bold flex-shrink-0" data-id="element-493">✅</span>
              <span className="text-white text-sm" data-id="element-494">
                Português Brasileiro (no de Portugal)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}